<template>
  <div class="baseProduct">
    <div class="baseProductContent"  v-if="!detailShow">
      <ul>
        <li
          v-for="(item,index) in imgList"
          :key="index"
          :style="{marginRight:(index+1)%3==0?'0':'60px'}"
          @click="imgClick(item)" >
          <a href="#">
            <img :src="imageUrl+item.productLogo" alt/>
          </a>
          <p>{{item.createTime}}</p>
          <p style="font-size:15px;" v-if="langes==0">{{item.title}}</p>
          <p style="font-size:15px;" v-else>{{item.titleEn}}</p>
        </li>
      </ul>
    </div>
    <div  v-else>
      <el-button type="primary" @click="back" icon="el-icon-back"></el-button>
      <p class="detailTitle">
          <span>{{detailObj.createTime}}</span>
          {{detailObj.title}}
      </p>
       <p v-html="detailObj.content"></p>
    </div>
     <div class="bottom" v-if="!detailShow">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="searchObj.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    currentObj: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      currentPage: 1,
      total: 0,
      imageUrl: this.$api.imageUrl,
      imgList: [],
      searchObj: {
        pageNum: 1,
        pageSize: 9
      },
      detailObj: {},
      detailShow: false,
      langes: 0
    }
  },
  inject: ['parentEle'],
  mounted() {
    this.getList();
    this.detailShow = false;
    this.langes = sessionStorage.getItem('watchStorage');
    window.addEventListener('setItem', () => {
      this.langes = sessionStorage.getItem('watchStorage');
    })
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchObj.pageNum = val;
      this.getList();
    },
    // 获取列表
    getList() {
      this.$api.get(`/api/web/get_product_list`, {
        ...this.searchObj
      }).then(res => {
        this.imgList = [...res.response.list];
        this.total = res.response.total;
      })
    },
    imgClick(item) {
      this.detailObj = { ...item };
      this.detailShow = true;
    },
    back(){
      this.detailShow = false;
    }
  }
}
</script>
<style scoped lang="less">
.baseProduct {
  width: 100%;
  .baseProductContent {
    padding:12px 20px;
    color: #706f6f;
    line-height: 1.8;
    overflow: auto;
    height: 650px;
    li {
      width: 230px;
      height: 350px;
      float: left;
      text-align: center;
      margin-bottom: 20px;
      margin-right: 15px;
      padding-bottom: 10px;
      box-shadow: #c7c7c7 0 4px 4px;
      img {
        width: 230px;
        height: 230px;
      }
    }

  }
  .bottom {
      width: 100%;
      margin-top: 10px;
      display: flex;
      justify-items: center;
      justify-content: center;
      align-items: center;
    }
  .detailTitle {
    display: block;
    border-bottom: 1px solid #1069b6;
    font-weight: bold;
    font-size: 17px;
    color: #1069b6;
    text-align: left;
    padding-bottom: 4px;
    line-height: 28px;
    span {
      float: right;
      line-height: 28px;
      color: #666;
      font-weight: normal;
      font-size: 11px;
    }
  }
  .productTitle{
    overflow: auto;
    height: 650px;
  }
}
</style>